module.exports = __webpack_public_path__ + "static/media/page02_two_lady.80fd8ca3.png";